// extracted by mini-css-extract-plugin
export default {"PageContent":"PageContent1QOeABNCeotC","PageContent_fullWidth":"PageContent_fullWidth2zxmbCWh4Txv","PageContent_condensed":"PageContent_condensedDPJsFHkAugzo"};